module.exports = __webpack_public_path__ + "img/fonetti_404.e8fe86bd.png";